import React from 'react';
import { Link } from 'gatsby';

import '../../styles/common/big-link.scss';

const BigLink = (props) => (
  <div className="big-link">
    <Link to={props.to}>
        {props.label}
    </Link>
  </div>
);

export default BigLink;